import D, { useState as y, useEffect as l } from "react";
import k from "@vectord/modal";
import { cx as b } from "@vectord/ui";
function L() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
function m() {
  return /tablet|iPad/i.test(navigator.userAgent) ? "tablet" : L() ? "mobile" : "desktop";
}
function T() {
  let t;
  if (document.cookie.match(/_ga=(.+?);/)) {
    const o = /_ga=(.+?);/;
    t = document.cookie.match(o)[1].split(
      "."
    ).slice(-2).join(".");
  }
  return t;
}
const x = (t) => {
  const e = document.cookie.split(";").find(
    (i) => i.trim().startsWith(`${t}=`)
  ), n = e == null ? void 0 : e.split("=").slice(1).join("=");
  return n ? decodeURIComponent(n) : void 0;
}, E = (t) => {
  typeof window.dataLayer < "u" && window.dataLayer.push(t);
};
function M(t) {
  if (!t)
    return {};
  let o = t;
  t.startsWith("/") && (o = window.location.origin + t);
  try {
    const e = new URL(o);
    let n = e.pathname;
    return n.endsWith("/") || (n += "/"), {
      destination_url: e.href,
      destination_host: e.host,
      destination_path: n
    };
  } catch {
    return {};
  }
}
function S({
  element: t,
  link: o,
  text: e,
  category: n,
  ...i
}) {
  const s = e ? e.substring(0, 999) : void 0, c = {
    element: t,
    text: s,
    ...i
  }, a = M(o), r = {
    ...c,
    ...a
  };
  E({
    event: "gtm_custom_click",
    category: "exit-intent",
    label: t,
    action: "gtm_custom_click",
    attributes: r
  });
}
function g(t, o, e) {
  const n = o || t, i = window.exitIntentTrackingUserData, s = window.location.href;
  S({
    element: n,
    ...e || {},
    ...i,
    link: s
  });
}
function U(t, o, e) {
  const n = /* @__PURE__ */ new Date(), i = n.getTimezoneOffset();
  window.exitIntentTrackingUserData = {
    cu_date: n,
    cu_timezone_offset: i,
    user_analytics_identifier: x("user_analytics_identifier"),
    google_client_id: T(),
    request_source: m(),
    device: m(),
    user_id: t,
    company: "scaler",
    product: o,
    subproduct: e
  };
}
const v = "exit-intent-modal", h = (t = v) => !sessionStorage.getItem(t), _ = (t = v) => {
  sessionStorage.setItem(t, "true");
};
function A() {
  return window.innerWidth <= 480;
}
const W = ({
  children: t,
  onClose: o = () => {
  },
  wrapperClassName: e = "",
  mobileDelay: n = 3e4,
  userId: i,
  product: s,
  subproduct: c,
  exitIntentId: a
}) => {
  const [r, d] = y(!1);
  l(() => {
    U(i, s, c);
  }, [s, c, i]), l(() => {
    r && g("cta", "exit-intent-modal-open", {});
  }, [r]), l(() => {
    const u = (f) => {
      h(a) && !(f.relatedTarget instanceof HTMLElement) && f.clientY < 10 && (d(!0), _(a));
    }, p = () => {
      setTimeout(() => {
        d(!0), _(a);
      }, n);
    };
    return h(a) && (A() ? p() : document.addEventListener("mouseleave", u)), () => {
      document.removeEventListener("mouseleave", u);
    };
  }, [a, n]);
  const w = () => {
    g("cta", "exit-intent-modal-close", {}), d(!1), o && o();
  };
  return r ? /* @__PURE__ */ D.createElement(
    k,
    {
      isOpen: r,
      onClose: w,
      className: b("vd-bg-surface-neutral-inverse-base/[0.8] vd-opacity-100 vd-items-center", e)
    },
    t
  ) : null;
};
export {
  W as ExitIntent
};
